import { useState, useEffect, useRef, useCallback } from 'react';

export function useModal(initialState = false) {
    const [isModalVisible, setIsModalVisible] = useState(initialState);

    const showModal = useCallback(() => {
        setIsModalVisible(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsModalVisible(false);
    }, []);

    return [isModalVisible, closeModal, showModal];
}

export function useTick(refreshRate, initialState = false) {
    const [tick, setTick] = useState(initialState);
    const handleRef = useRef();

    function resetTick() {
        clearInterval(handleRef.current);
        handleRef.current = null;

        if (refreshRate > 0) {
            handleRef.current = setInterval(() => setTick(true), refreshRate);
        }
    }

    useEffect(() => {
        if (refreshRate > 0) {
            handleRef.current = setInterval(() => setTick(true), refreshRate);
        }

        return () => {
            clearInterval(handleRef.current);
            handleRef.current = null;
            setTick(false);
        };
    }, [refreshRate]);

    useEffect(() => {
        if (tick) {
            setTick(false);
        }
    }, [tick]);

    return [tick, resetTick];
}
